import React from 'react';
import { Check } from 'lucide-react';
const steps = ['গাড়ি', 'মালিক', 'চালক', 'সম্পন্ন'];
export function VerifyStepper({
  current
}: {
  current: number;
}) {
  return <div className="flex items-center gap-1 border-b border-border bg-white px-4 py-2.5" aria-label="যাচাইয়ের ধাপ" data-id="element-1234" data-mp="2dfkyyu07ts6n">
      {steps.map((s, i) => <React.Fragment key={s} data-id="element-1235" data-mp="2idd26k6b90q5" data-mpi={i}>
          <div className="flex items-center gap-1.5" data-id="element-1236" data-mp="2icl492p8qqwp">
            <span className={`flex h-5 w-5 items-center justify-center rounded-full text-[10px] font-bold ${i < current ? 'bg-bdgreen-600 text-white' : i === current ? 'bg-navy-800 text-white' : 'bg-slate-200 text-slate-500'}`} data-id="element-1237" data-mp="24dv75n2f8r8c">
              {i < current ? <Check className="h-3 w-3" strokeWidth={3} data-id="element-1238" data-mp="1zgv0b9xqzkg6" /> : ['১', '২', '৩', '৪'][i]}
            </span>
            <span className={`text-[11px] font-medium ${i <= current ? 'text-navy-900' : 'text-slate-400'}`} data-id="element-1239" data-mp="3ow1jh1qmmz0d">{s}</span>
          </div>
          {i < steps.length - 1 && <span className={`h-px flex-1 ${i < current ? 'bg-bdgreen-600' : 'bg-slate-200'}`} data-id="element-1240" data-mp="22wjtadz91xhk" />}
        </React.Fragment>)}
    </div>;
}